class CnpjUtils {
	static cleanCnpj(cnpj) {
		return (cnpj || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
	}

	static formatCnpj(raw) {
		const clean = CnpjUtils.cleanCnpj(raw).slice(0, 14);
		let formatted = clean;
		if (clean.length > 2) formatted = clean.slice(0, 2) + "." + clean.slice(2);
		if (clean.length > 5) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5);
		if (clean.length > 8) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8);
		if (clean.length > 12) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8, 12) + "-" + clean.slice(12);
		return formatted;
	}

	static isValidCnpj(cnpj) {
		const clean = CnpjUtils.cleanCnpj(cnpj);
		if (clean.length !== 14) return false;
		if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(clean)) return false;
		if (/^(.)\1{13}$/.test(clean)) return false;

		const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		const valores = clean.split("").map(c => c.charCodeAt(0) - 48);

		const soma1 = valores.slice(0, 12).reduce((acc, val, idx) => acc + val * pesos1[idx], 0);
		const resto1 = soma1 % 11;
		const dv1 = resto1 < 2 ? 0 : 11 - resto1;
		if (dv1 !== valores[12]) return false;

		const soma2 = valores.slice(0, 13).reduce((acc, val, idx) => acc + val * pesos2[idx], 0);
		const resto2 = soma2 % 11;
		const dv2 = resto2 < 2 ? 0 : 11 - resto2;
		return dv2 === valores[13];
	}

	static cleanAlphanumericCnpj(cnpj) {
		return cnpj.replace(/[^A-Z0-9]/gi, '').toUpperCase();
	}

	static formatAlphanumericCnpj(cnpj) {
		if (!cnpj) {
			return "";
		}

		const cleanCnpj = this.cleanAlphanumericCnpj(cnpj);

		if (!/^[A-Z0-9]{12}\d{2}$/.test(cleanCnpj)) {
			return cleanCnpj;
		}

		return cleanCnpj.replace(
			/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
			"$1.$2.$3/$4-$5"
		);
	}

	static getAlphanumericCnpjMask() {
		const alphanumeric = /[A-Za-z0-9]/;
		const numeric = /\d/;

		return [
			alphanumeric, alphanumeric, ".",
			alphanumeric, alphanumeric, alphanumeric, ".",
			alphanumeric, alphanumeric, alphanumeric, "/",
			alphanumeric, alphanumeric, alphanumeric, alphanumeric, "-",
			numeric, numeric
		];
	}

	static partiallyHideCnpj(cnpj) {
		const cleanCnpj = this.cleanAlphanumericCnpj(
			String(cnpj ?? "")
		);

		if (cleanCnpj.length !== 14) {
			return "-";
		}

		return `xx.xxx.xxx/${cleanCnpj.slice(8, 12)}-xx`;
	}

	static isCompleteAlphanumericCnpj(cnpj) {
		const cleanCnpj = CnpjUtils.cleanAlphanumericCnpj(
			String(cnpj ?? "")
		);

		return /^[A-Z0-9]{12}\d{2}$/.test(cleanCnpj);
	}
}

export default CnpjUtils;
